// A clock that re-renders its component every `intervalMs`. Status derived
// from "time since last seen" has to advance on its own: a poll that returns
// unchanged data re-renders nothing (TanStack Query keeps the previous object),
// so a stopped posting service would otherwise read "Online" indefinitely.

import { useEffect, useState } from "react";
import { STATUS_REFRESH_MS } from "@/api/status";

export function useNow(intervalMs: number = STATUS_REFRESH_MS): Date {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);
    return now;
}
